import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import {
  Header,
  HeaderChatButton,
  HeaderBackButton,
  HeaderNextNavButton,
  HeaderNav,
  HeaderPrevNavButton,
  useHeaderNav,
} from '@/ui/components/header';
import { conflictsQuery } from '@/features/conflicts/queries';
import { ConflictsDetailPage } from '@/features/conflicts/components/conflicts-detail-page';
import { useFilteredConflicts } from '@/features/conflicts/helpers';
import { useSuspenseQuery } from '@tanstack/react-query';
import { NotFound } from '@/ui/components/not-found';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId',
)({
  staticData: { chatSurface: 'conflict_finder' },
  component: RouteComponent,
});

function RouteComponent() {
  const { workspaceId, projectId, conflictId } = Route.useParams();
  const workspace = useWorkspace();

  const { data: analysisData } = useSuspenseQuery(conflictsQuery(workspace.type, workspaceId));

  const conflicts = useFilteredConflicts();
  const { handlePrevious, handleNext, isPreviousDisabled, isNextDisabled } = useHeaderNav(
    conflicts.map((finding) => ({ id: finding.findingId })),
    conflictId,
    (id) => ({
      to: '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId',
      params: { projectId, workspaceId, conflictId: id },
    }),
  );

  const item = analysisData?.findings.find((finding) => finding.findingId === conflictId);

  if (!item) return <NotFound />;

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/conflicts"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/conflicts"
            params={{ projectId, workspaceId }}
          >
            {t({ en: 'Conflicts', nb: 'Motstrid' })}
          </BreadcrumbLink>
          <BreadcrumbPage className="tabular-nums">#{item.displayNumber}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderNav>
          <HeaderPrevNavButton onClick={handlePrevious} disabled={isPreviousDisabled} />
          <HeaderNextNavButton onClick={handleNext} disabled={isNextDisabled} />
        </HeaderNav>
        <HeaderChatButton />
      </Header>
      <ConflictsDetailPage />
    </>
  );
}
